import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/v1/borrowing-spare-parts', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/v1/borrowing-spare-parts/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/v1/borrowing-spare-parts', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = (id, data) => {
  return httpClient
    .put(`/api/v1/borrowing-spare-parts/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/v1/borrowing-spare-parts/${id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const findEngine = customerId => {
  return httpClient
    .get(`/api/v1/borrowing-spare-parts/${customerId}/engine-numbers`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const formModel = (Options = {}) => {
  return httpClient
    .get('/api/v1/borrowing-spare-parts/form-view-models', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const toPdf = (id, data) => {
  return httpClient
    .get(`/api/v1/borrowing-spare-parts/${id}/to-pdf`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const combineInvoice = (Options = {}) => {
  return httpClient
    .get(`/api/v1/borrowing-spare-parts/combine-invoices`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const generateInv = data => {
  return httpClient
    .post(`/api/v1/borrowing-spare-parts/generate-to-invs`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const updateRef = (id, data) => {
  return httpClient
    .put(`/api/v1/borrowing-spare-parts/${id}/references`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const productBalance = data => {
  return httpClient
    .post(`/api/v1/borrowing-spare-parts/product-balances`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const getLocation = (Options = {}) => {
  return httpClient
    .get('/api/v1/borrowing-spare-parts/locations', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export default {
  get,
  find,
  store,
  update,
  destroy,
  formModel,
  findEngine,
  toPdf,
  combineInvoice,
  generateInv,
  updateRef,
  productBalance,
  getLocation
}
